import { ENTRY_DATA_SECTION_KEYS } from "@frontend/common";

import { ArticleEntryData } from "@/types/articleEntryData.types";
import { DealLaScSection } from "@/types/dealLaSc.types";
import {
  DEFAULT_FOCUS_STATUS,
  useTableCreatorFocusStatus,
} from "@FillInTableContainer/shared/context/TableCreatorFocusStatusContext";
import { useTableCreatorCurrentHistory } from "@FillInTableContainer/shared/context/TableCreatorHistoryContext";
import {
  DEFAULT_POSITION_INFO,
  useTableCreatorPositionInfo,
} from "@FillInTableContainer/shared/context/TableCreatorPositionInfoContext";
import { useEntryDataState } from "@stores/entryData";
import { getPressIdFromURL } from "@utils/getStateFromURL";

interface Props {
  groupTableKey: DealLaScSection;
  groupTableIndex: number;
  groupShellSectionKey: string | null;
  groupShellSectionIndex: number | null;
  tableKey: string | null;
  tableIndex: number;
}

const useDealLaScRightsScopeGroupShellSection = ({
  groupShellSectionIndex,
  groupShellSectionKey,
  groupTableIndex,
  groupTableKey,
  tableIndex,
  tableKey,
}: Props) => {
  const [entryData, setEntryData] = useEntryDataState(getPressIdFromURL());
  const { focusStatus, changeFocusStatus } = useTableCreatorFocusStatus();
  const { changeCurrentHistory } = useTableCreatorCurrentHistory();

  const { info, changeInfo } = useTableCreatorPositionInfo();

  const handleClearGroupShellSection = () => {
    const clearRightScopeGroupShellSection = (): ArticleEntryData => {
      if (info.groupShellSectionIndex === null) return entryData;
      if (info.groupShellSectionKey !== " Rights Scope Row") return entryData;

      return {
        ...entryData,
        [ENTRY_DATA_SECTION_KEYS.dealsLaSc]: {
          ...entryData[ENTRY_DATA_SECTION_KEYS.dealsLaSc],
          "Rights Scope Table": entryData[ENTRY_DATA_SECTION_KEYS.dealsLaSc]?.[
            "Rights Scope Table"
          ]?.map((groupShellInfo) => {
            return {
              ...groupShellInfo,
              Asset: {
                ...groupShellInfo.Asset,
                value: [],
              },
              Exclusivity: {
                ...groupShellInfo.Exclusivity,
                value: [],
              },
              "Intended Use": {
                ...groupShellInfo["Intended Use"],
                value: [],
              },
              "Rights Limitation": {
                ...groupShellInfo["Rights Limitation"],
                value: [],
              },
              "Rights Scope": {
                ...groupShellInfo["Rights Scope"],
                value: [],
              },
              "Rights Scope Type": {
                ...groupShellInfo["Rights Scope Type"],
                value: [],
              },
              Territory: {
                ...groupShellInfo.Territory,
                value: [],
              },
              "Territory Include": {
                ...groupShellInfo["Territory Include"],
                value: [],
              },
              "Territory Exclude": {
                ...groupShellInfo["Territory Exclude"],
                value: [],
              },
              "Rights Flow": {
                "Axis Direction": {
                  ...groupShellInfo["Rights Flow"]?.["Axis Direction"],
                  value: [],
                },
                "Benefiting Axis": {
                  ...groupShellInfo["Rights Flow"]?.["Benefiting Axis"],
                  value: [],
                },
                "Contributing Axis": {
                  ...groupShellInfo["Rights Flow"]?.["Contributing Axis"],
                  value: [],
                },
              },
            };
          }),
        },
      };
    };

    if (info.groupShellSectionKey === "Rights Scope Row") {
      setEntryData(clearRightScopeGroupShellSection());
      changeCurrentHistory({
        entryData: clearRightScopeGroupShellSection(),
        changedDataInfo: {
          target: "groupShellSection",
          action: "clear",
          position: {
            groupTableIndex,
            groupTableKey,
            tableKey,
            tableIndex,
            groupShellSectionKey,
            groupShellSectionIndex,
            groupShellIndex: null,
            groupShellKey: null,
            subGroupShellIndex: null,
            subGroupShellKey: null,
            shellKey: null,
            shellIndex: null,
            valueIndex: null,
            value: null,
          },
        },
      });
      changeFocusStatus(DEFAULT_FOCUS_STATUS);
      changeInfo(DEFAULT_POSITION_INFO);
    }
  };

  const handleClickToClearLicenseeTableGroupShellSection = () => {
    if (focusStatus.type === "clear") {
      handleClearGroupShellSection();
    }
  };

  return { handleClickToClearLicenseeTableGroupShellSection };
};

export default useDealLaScRightsScopeGroupShellSection;
